import _ = require('lodash')
const moment = require('moment-timezone')

const cardInfo = [
  {
    text: 'Mobiphone', value: 'MP'
  },
  {
    text: 'Vinaphone', value: 'VP'
  },
  {
    text: 'Viettel', value: 'VT'
  },
  {
    text: 'VietnamMobile', value: 'VNM'
  },
]
const cardMoneyInfo = [
  {
    text: '20.000', value: '20'
  },
  {
    text: '50.000', value: '50'
  },
  {
    text: '100.000', value: '100'
  },
  {
    text: '200.000', value: '200'
  },
  {
    text: '500.000', value: '500'
  },
]

const calculatePickedVnd = (pickedItems: IGameItem[]): number => {
  if (!pickedItems || pickedItems.length <= 0) {
    return 0
  }
  let amount = pickedItems
    .map(value => value.outVnd)
    .reduce((previousValue, currentValue) => previousValue + currentValue)
  return (Math.ceil(amount / 1000) * 1000)
}

const calculatePickedValue = (pickedItems: IGameItem[]): string => {
  if (!pickedItems || pickedItems.length <= 0) {
    return '0 $'
  }
  let amount = pickedItems
    .map(value => value.rawValue)
    .reduce((previousValue, currentValue) => previousValue + currentValue)
  return amount.toLocaleString('en') + '$'
}

const calculateFee = (amount: number, feeFactor?: number): number => {
  if (_.isNil(feeFactor)) {
    return amount
  }
  const fee = amount * feeFactor
  return (Math.ceil(fee / 1000) * 1000) + amount
}

const calculateOrders = (lineOrderInfos: ILineOrderInfo[]): string => {
  if (!lineOrderInfos || lineOrderInfos.length <= 0) {
    return '0 đ'
  }
  let amount = lineOrderInfos
    .map(value => value.quantity * value.price)
    .reduce((previousValue, currentValue) => previousValue + currentValue)
  return amount.toLocaleString('vn') + 'đ'
}

const showRemainAmount = (totalVnd: number, user?: IUser): number => {
  if (!user) {
    return 0
  }
  return (user.amount - totalVnd)
}

const toLocaleDateTime = (dateTime?: Date): string => {
  return dateTime ?
    moment.tz(dateTime, 'UTC').tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD HH:mm:ss')
    : ''
}

const getActiveBank = (code: string, allBank: IBankInfo[]): IBankInfo | undefined => {
  return _.find(allBank, {code: code, active: true})
}

export const roundToVnd = (value: number) => {
  return Math.ceil(value / 1000) * 1000
}

export const calculateTipVnd = (tipInUsd: number, rate: number) => {
  const tipInVnd = tipInUsd * rate * 1000
  return roundToVnd(tipInVnd)
}

export const calculateVndToTip = (vnd: number, rate: number) => {
  const usd = vnd / (rate * 1000)
  return Math.floor(usd * 100) / 100
}

export const common = {
  getActiveBank,
  calculatePickedVnd,
  calculatePickedValue,
  cardInfo,
  cardMoneyInfo,
  calculateOrders,
  showRemainAmount,
  calculateFee,
  toLocaleDateTime,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/common.ts